<template>
    <section class="footer">
        <div class="footer-dark">
            <footer>
                <div class="container">
                    <div class="row">
                        <div class="col item social">
                            <!-- <a href="#"><i class="fab fa-facebook"></i></a> -->
                            <a :href=emailAddr><i class="fa fa-envelope"></i></a>
                            <a href="#"><i class="fa fa-phone-square"></i></a>
                            <a href="http://wpa.qq.com/msgrd?v=3&uin=18032746&site=qq&menu=yes"><i
                                    class="fa fa-qq"></i></a>
                        </div>
                    </div>
                    <p class="copyright">SimYuan © 2022&nbsp; &nbsp;&nbsp;<a target="_blank"
                            href="https://beian.miit.gov.cn/">{{ filing }}</a></p>
                </div>
            </footer>
        </div>
    </section>
</template>

<script>
export default {
    name: 'footer',
    data() {
        return {
            emailAddr: 'mailto:' + this.email
        }
    },
    components: {},
    props: {
        email: { type: String, default: 'workmoto@126.com', },
        filing: { type: String, default: '湘ICP备18015120号-1', },
    },
    watch: {},
    mounted() { },
    methods: {}
}
</script>

<style scoped>
.footer-dark {
    padding: 50px 0;
    color: #f0f9ff;
    background-color: #282d32;
}

.footer-dark .copyright {
    text-align: center;
    padding-top: 24px;
    opacity: 0.3;
    font-size: 13px;
    margin-bottom: 0;
}

.footer-dark .item.social>a {
    font-size: 20px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgb(255 255 255 / 40%);
    margin: 0 8px;
    color: #fff;
    opacity: 0.75;
}
</style>
